import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import {
	Validator
} from 'vee-validate'

export default {
	name: 'Packingreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader
	},
	data: function () {
		return {
			isLoadingforxls: false,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			// totalRows: 0,
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			listDataTransmissionData: [],
			listDataTransmissionDataCsv: [],
			listWarehouseData: [],
			listPackingReportDataCsv: [],
			listuserData: [],
			csvFields: [],
			datenow: '',
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			transcationfromdate: '',
			transactiontodate: '',
			formattedDate: '',
			Transmissiontype: '',
			resultCount: '',
			listClientData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',

			client: '',
			ClientErr: '',
			UidErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			UILflag: false,
			user_type: '',
			EmailUID: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			userid: '',
			recordLimit: 0,
			limitExeed: false
		}
	},
	created: function () { },
	// when a page loads,mounted() will be call
	mounted() {

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('editedjson.logReport'),
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
	},
	methods: {

		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getDataTransmissinreportDataForXls(3)
			}
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {

		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;

		// 		if (this.user_type != 'warehouse_user') {
		// 			this.totalRows = 0
		// 			this.listDataTransmissionData = []
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {

		// 			if (this.warehouseid && this.clientid);
		// 			// this.getDataTransmissinreportData();
		// 		}
		// 	}

		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	this.listDataTransmissionData = [];
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getDataTransmissinreportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getDataTransmissinreportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getDataTransmissinreportData(2);
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 00:00:00');
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 23:59:00');
		},
		isNumeric: function (n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},
		//to get Stock list
		getDataTransmissinreportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var packingto_date = '';
			var packingfr_date = '';
			this.ClientErr = '';
			this.UidErr = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listDataTransmissionData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listDataTransmissionData = [];
				return false;
			}
			if (this.isNumeric(this.EmailUID)) {
				this.EmailUID = this.EmailUID
			}
			if (this.EmailUID && !this.isNumeric(this.EmailUID)) {
				this.UILflag = true;
				this.UidErr = this.$t('editedjson.emailIdnumeric');
				this.pageno = this.totalPage = 0;
				this.listDataTransmissionData = [];
				return false;
			}
			this.isLoading = true;
			if (this.transcationfromdate == '') {
				packingfr_date = '';
			} else {

				packingfr_date = this.dateFormat(this.transcationfromdate)
			}

			if (this.transactiontodate == '') {
				packingto_date = '';
			} else {
				packingto_date = this.dateFormat2(this.transactiontodate)
			}
			// if (this.Transmissiontype == 'racks') {
			// 	this.client = '';
			// }
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: packingfr_date,
				todate: packingto_date,
				datatransmissiontype: this.Transmissiontype,
				uid: this.EmailUID,
				clientid: window.localStorage.getItem('selectedClient'),
				csvData: csvCheck,
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				userid: this.userid
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getDataTranscationloglist',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.csvFields = {
								'datatransmissiontype': this.$t('dataUploadLogs.dataTransmissionType'),
								'createddate': this.$t('dataUploadLogs.uploadDateandTime'),
								'uploadtype': this.$t('dataUploadLogs.uploadFrom'),
								'createdby': this.$t('dataUploadLogs.uploadBy'),
								'uid': this.$t('editedjson.wmsemaildId'),
								'totalqty': this.$t('dataUploadLogs.totalRecords'),
								'totalacceptedqty': this.$t('dataUploadLogs.newRecords'),
								'totalupdatedqty':  this.$t('dataUploadLogs.updatedRecords'),
								'totalrejectedqty': this.$t('dataUploadLogs.failedRecords'),
								'clientid': this.$t('client.clientId'),
								'modifiedby': this.$t('editedjson.Modifiedby'),
								'modifieddate': this.$t('editedjson.modifieddate')

							};
							var dateFilder = [];
							var skipFilter = ['transcationdate'];
							this.listDataTransmissionDataCsv = result.data.data;
							// csvHelper.data.jsonToCSV('LogReport', this.listDrReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
							this.jsonToCSV(this.$t('editedjson.logReport'), this.listDataTransmissionDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listDataTransmissionData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0
						} else {
							this.totalRows = result.data.count;
							this.resultCount = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}

					// }
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})

		},
		getDataTransmissinreportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var packingto_date = '';
			var packingfr_date = '';
			this.ClientErr = '';
			this.UidErr = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.isNumeric(this.EmailUID)) {
				this.EmailUID = this.EmailUID
			}
			if (this.EmailUID && !this.isNumeric(this.EmailUID)) {
				this.UILflag = true;
				this.UidErr = 'WMS Email UID is numeric';
				this.pageno = this.totalPage = 0;
				this.listDataTransmissionData = [];
				return false;
			}


			if (this.transcationfromdate == '') {
				packingfr_date = '';
			} else {

				packingfr_date = this.dateFormat(this.transcationfromdate)
			}

			if (this.transactiontodate == '') {
				packingto_date = '';
			} else {
				packingto_date = this.dateFormat2(this.transactiontodate)
			}
			if (this.Transmissiontype == 'racks') {
				this.client = '';
			}
			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fromdate: packingfr_date,
				todate: packingto_date,
				datatransmissiontype: this.Transmissiontype,
				uid: this.EmailUID,
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
				csvData: csvCheck,
				userid: this.userid
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getDataTranscationloglist',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('dataUploadLogs.dataTransmissionType')]= 'datatransmissiontype';
							this.csvFieldsForXls[this.$t('dataUploadLogs.uploadDateandTime')]= 'createddate';
							this.csvFieldsForXls[this.$t('dataUploadLogs.uploadFrom')]= 'uploadtype';
							this.csvFieldsForXls[this.$t('dataUploadLogs.uploadBy')]= 'createdby';
							this.csvFieldsForXls[this.$t('editedjson.wmsemaildId')]= 'uid';
							this.csvFieldsForXls[this.$t('dataUploadLogs.totalRecords')]= 'totalqty';
							this.csvFieldsForXls[this.$t('dataUploadLogs.newRecords')]= 'totalacceptedqty';
							this.csvFieldsForXls[this.$t('dataUploadLogs.failedRecords')]= 'totalrejectedqty';
							this.csvFieldsForXls[this.$t('client.clientId')]= 'clientid';
							this.csvFieldsForXls[this.$t('editedjson.Modifiedby')]= 'modifiedby';
							this.csvFieldsForXls[this.$t('editedjson.modifieddate')]= 'modifieddate';
							

							this.listReportDataforxls = result.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}


				},
					error => {
						console.error(error)
					})
				
		},
		//to reset search form
		resetForm() {
			this.show = false;
			this.download = true;
			this.totalRows = 0
			this.EmailUID = '';
			this.transcationfromdate = '';
			this.transactiontodate = '';
			this.Transmissiontype = '';
			this.listDataTransmissionData = [];
			this.pageno = this.totalPage = 0;
			this.searchFlag = false;
			// this.getDataTransmissinreportData();
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		//to paginate  GRC List
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getDataTransmissinreportData()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getDataTransmissinreportData()
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/datatransmissionlogreport/datatransmissionlogreport.component.js